import script from "./CompanyGroupTableActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyGroupTableActions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__